<template>
  <RevList :has-external-borders="false">
    <RevListItemInteractive @click="handleSelectListItem('all')">
      <template #label>
        {{ i18n(translations.all) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>

    <RevListItemInteractive
      @click="handleSelectListItem('missing-imei-numbers')"
    >
      <template #label>
        {{ i18n(translations.missingImeiNumbers) }}
      </template>
      <template #description>
        {{ i18n(translations.missingImeiNumbersDescription) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>

    <RevListItemInteractive @click="handleSelectListItem('delivery-slips')">
      <template #label>
        {{ i18n(translations.deliverySlips) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>

    <RevListItemInteractive
      v-if="isFeatureEnabled('backshipEnabled')"
      @click="handleSelectListItem('backship-labels')"
    >
      <template #label>
        {{ i18n(translations.backshipLabels) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>

    <RevListItemInteractive
      v-if="isFeatureEnabled('customerReceiptEnabled')"
      @click="handleSelectListItem('invoices')"
    >
      <template #label>
        {{ i18n(translations.invoices) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>
  </RevList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import type { ListItem } from '../../ExportDrawer.types'

import translations from './List.translations'

const i18n = useI18n()

const emit = defineEmits(['select-list-item'])

const { isFeatureEnabled } = useBusinessFeaturesStore()

function handleSelectListItem(listItem: ListItem) {
  emit('select-list-item', listItem)
}
</script>
